import { Shape } from './Shape.js';
import { fabric } from 'fabric';
import { fabricObjectExtend } from '../DrawingUtil.js';
import { ShapeAction } from './ShapeFactory.js';
var defaultProps = {
    stroke: 'red',
    strokeWidth: 3
};
class FreeHand extends Shape {
    constructor(props) {
        super(props);

        this.newProps;
        this.fabricItem;
    }
    draw(props, drawingCanvas) {
        this.drawingCanvas = drawingCanvas;
        this.newProps = { ...defaultProps, ...props };
        if (props.action !== ShapeAction.START) {
            this.fabricItem = new fabric.Path(this.newProps.path, this.newProps);
            super.draw(this.fabricItem);
            return;
        }
        const events = {
            onCanvasObjectAdded: this.onCanvasObjectAdded.bind(this),
            onCanvasMouseUp: this.onMouseUp.bind(this)
        };
        this.drawingCanvas.registerEvents(events);
    }
    onMouseDown(points) {
        //this.drawingCanvas.toggleDrawingMode(true);
        
    }

    onMouseUp() {
        this.drawingCanvas.removeEvents();
        //this.drawingCanvas.toggleDrawingMode(false);
    }
    onCanvasObjectAdded(event) {
        var fabricItem = event.target;
        var targetObject = fabricItem.toObject();

        /** IMPORTANT:
         * "&& !targetObject.uuid" --> is neccessary to avoid
         * deadlock of freehand object added event
         */
        if (!targetObject.uuid) {
            fabricObjectExtend(fabricItem);
            fabricItem.uuid = this.newProps.uuid;
            fabricItem.uuid_parent = this.newProps.uuid_parent;
            this.drawingCanvas.renderAll();
            targetObject.uuid = fabricItem.uuid;
            targetObject.uuid_parent = fabricItem.uuid_parent;
            const props = { ...this.newProps, ...targetObject };
            props.action = ShapeAction.ADD;
            this.drawingCanvas.setActiveShape(fabricItem);
            this.onDrawCompleted && this.onDrawCompleted(props);
        }
    }
}

export { FreeHand };
